import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a31cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "employee-multiselect" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"width":"1.5rem","height":"1.5rem"} }
const _hoisted_4 = { class: "employee-multiselect__selected-users" }
const _hoisted_5 = { class: "employee-multiselect__selected-users--data" }

import { computed, PropType } from 'vue';
import { UserModel } from '../../models';
import {
  TirPmMultiselect,
  TirPmSelectBadge,
  TirPmIconView,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  PopoverPositionEnum,
  TirPmScrollbar,
} from 'tir-components';
import { EmployeeMultiselectOptionModel } from './models';
import { PlusIcon, TrashIcon } from 'tir-style-system/icons/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'employee-multiselect',
  props: {
  /**Выбранные сотрудники */
  modelValue: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Сотрудники для выбора */
  employees: {
    type: Array as PropType<Array<UserModel>>,
    requred: true,
  },
  /**Ширина */
  width: {
    type: String,
    default: '100%',
  },
  /**Лейбл */
  label: {
    type: String,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





/**Опции для мультиселекта */
const options = computed(() =>
  props.employees.map(
    (employee) =>
      new EmployeeMultiselectOptionModel({
        Id: employee.Id,
        FirstName: employee.FirstName,
        LastName: employee.LastName,
        AvatarColor: employee.AvatarColor,
        ImageUrl: employee.ImageUrl,
      }),
  ),
);

/**Выбранные опции */
const selectedOptions = computed(() =>
  options.value.filter((option) => props.modelValue.some((employeeId) => option.Id === employeeId)),
);
/**Добавить юзера */
const selectEmployee = (employeeId: number) => {
  emit('update:modelValue', [...props.modelValue, employeeId]);
};
/**Удалить юзера */
const unSelectEmployee = (employeeId: number) => {
  emit(
    'update:modelValue',
    props.modelValue.filter((_employeeId) => employeeId !== _employeeId),
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmMultiselect), {
      popoverPosition: _unref(PopoverPositionEnum).Bottom,
      options: options.value,
      "selected-options": selectedOptions.value,
      label: __props.label,
      width: "100%",
      popoverWidth: "32.5rem",
      class: "employee-multiselect__select"
    }, {
      target: _withCtx(() => [
        _renderSlot(_ctx.$slots, "targer")
      ]),
      optionList: _withCtx(({ option }) => [
        _createElementVNode("div", {
          style: {"display":"flex","align-items":"center","gap":"0.625rem","padding":"0.75rem"},
          onClick: ($event: any) => (selectEmployee(option.Id))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(TirPmIconView), {
              size: 24,
              isBordered: false,
              isRounded: "",
              colorCode: option.AvatarColor,
              imageLoadUrl: option.ImageUrl
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.FirstAndFirstLetterFullname), 1)
              ]),
              _: 2
            }, 1032, ["colorCode", "imageLoadUrl"])
          ]),
          _createTextVNode(" " + _toDisplayString(option.FirstAndLastName), 1)
        ], 8, _hoisted_2)
      ]),
      left: _withCtx(() => [
        _renderSlot(_ctx.$slots, "left")
      ]),
      _: 3
    }, 8, ["popoverPosition", "options", "selected-options", "label"]),
    _createVNode(_unref(TirPmScrollbar), {
      class: "employee-multiselect__scrollbar",
      showOnHover: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(TirPmIconView), {
                size: 48,
                isBordered: false,
                isRounded: "",
                colorCode: option.AvatarColor,
                imageLoadUrl: option.ImageUrl
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.FirstAndFirstLetterFullname), 1)
                ]),
                _: 2
              }, 1032, ["colorCode", "imageLoadUrl"]),
              _createElementVNode("div", null, _toDisplayString(option.LastName) + " " + _toDisplayString(option.FirstName[0]) + ".", 1)
            ]),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Regular,
              onClick: ($event: any) => (unSelectEmployee(option.Id))
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(TrashIcon))
              ]),
              _: 2
            }, 1032, ["variant", "size", "onClick"])
          ]))
        }), 256))
      ]),
      _: 1
    })
  ]))
}
}

})